import ReactTooltip from 'react-tooltip';
import { useTranslation } from 'react-i18next';
// import { FaLock, FaRegEdit } from 'react-icons/fa';

function GigsPill({ object }) {
  const { t } = useTranslation('gigs');
  let obj = {
    status: '',
    classes: '',
  };

  if (object === 1) {
    obj = {
      status: t('gigs:pill-not-verified'),
      tooltip: '',
      classes: 'bg-pill-orange text-pill-orange',
    };
  }
  if (object === 2 || object === 3 || object === 6) {
    obj = {
      status: t('gigs:pill-processed'),
      tooltip: '',
      classes: 'bg-pill-green text-pill-green',
    };
  }
  if (object === 4) {
    obj = {
      status: t('gigs:pill-ineligible'),
      tooltip: '',
      classes: 'bg-red-700 text-red-700',
    };
  }
  if (object === 5) {
    obj = {
      status: 'Rejected',
      tooltip: '',
      classes: 'bg-red-700 text-red-700',
    };
  }
  if (object === 7) {
    obj = {
      status: 'Archived',
      tooltip: '',
      classes: 'bg-pill-green text-pill-green',
    };
  }
  return (
    <div className="tooltip-with-edit-icon-container">
      <ReactTooltip effect="solid" multiline />
      <div data-tip={obj.tooltip} className={`inline-block text-xxxs py-0 px-1 rounded uppercase bg-opacity-25 ${obj.classes}`}>
        {obj.status}
      </div>
      {/* <>{(object === 1) ? <FaRegEdit className="text-lg gig-claim-editable-pen-icon" /> : <FaLock className="text-lg text-sentric-submenu-icon" />}</> */}
    </div>
  );
}

export default GigsPill;
